var exports = {
  "B_": "Details__AGKrLk",
  "yJ": "OpenLastItem__8-RG3l",
  "nL": "tipsOuterWrapper__FT9cj8",
  "IN": "tipsInnerWrapper___QuZZg",
  "e1": "tipSummary__Cb3juq",
  "GR": "tipSummaryOpen__us-c0S",
  "tG": "tipName__AHlXjx",
  "Bf": "tipContent__rl8Tlu",
  "K0": "tipContentLastItem__fODaSE",
};

module.exports = exports;
